import { Brick, registerBrick } from 'olympe';
import { rgWrap, RGWrapper } from './helpers';

export default class RGGroupTuplesByIndexes extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array} data
     * @param {string} indexes
     * @param {function(!Array)} setGroupedData
     */
    update(_$, [data, indexes], [setGroupedData]) {
        // Get the indexes and make the grouping recursively
        const _indexes = indexes.split(',').map(index => parseInt(index));
        setGroupedData(groupBy(data.map(d => rgWrap(d)), _indexes, 0));
    }
}

registerBrick('0192288806aa3cc82b95', RGGroupTuplesByIndexes);

/**
 * Group data by indexes, for the given level
 * @param {!Array} wrappers
 * @param {!Array<number>} indexes
 * @param {number} level
 * @return {!Array}
 */
function groupBy(wrappers, indexes, level) {
    // End of recursion
    if(level >= indexes.length || !Array.isArray(wrappers)) {
        return wrappers;
    }

    // Get the current working index
    const index = indexes[level] - level;

    // Group the data in a Map
    const groupedWrappers = wrappers.reduce((parents, wrapper) => {
        // Split the tuple into parts
        const [wrapped, child] = splitTuple(wrapper, index, level);
        const key = wrapped.rgGetKey();

        // If this key is not in a group yet
        if(!parents.has(key)) {
            // Create the new group
            parents.set(key, wrapped);
        }

        // If there is a child, add it to the group
        //  (group the child itself also)
        if(child) {
            const parent = parents.get(key);
            parent.rgChildren.push(child);
        }

        // Done
        return parents;
    }, new Map());

    // Apply the grouping on the children
    return Array.from(groupedWrappers.values()).map(({ rgChildren, ...others }) => ({
        rgChildren: groupBy(rgChildren.map(c => rgWrap(c, level + 1)), indexes, level + 1),
        ...others
    }));
}

/**
 * @param {!RGWrapper} wrapper 
 * @param {number} index 
 * @param {number} level 
 * @return {[!RGWrapper, *]}
 */
function splitTuple(wrapper, index, level) {
    // Real tuple case
    if(wrapper._rgType === 'tuple') {
        // Extract the info
        const tuple = wrapper.rgObject;
        const wrapped = rgWrap(tuple[index], level);
        const before = tuple.slice(0, index);
        const after = tuple.slice(index + 1);
        const child = [...before, ...after];
        
        // Handle all cases
        if(child.length > 1) {
            return [wrapped, child];
        }
        else if(child.length > 0) {
            return [wrapped, child[0]];
        }
        else {
            return [wrapped, null];
        }
    }

    // Not a tuple case
    else {
        return [wrapper, null];
    }
}
